// @flow
export const SAVE_USER_PROFILE: string = "SAVE_USER_PROFILE";
export const CLEAR_USER_PROFILE: string = "CLEAR_USER_PROFILE";
export const UPDATE_USER_PROFILE: string = "UPDATE_USER_PROFILE";
